export default __webpack_public_path__ + "static/media/face3.543e4d27.jpg";